var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isRounded ?
    'ImagePlaceholder ImagePlaceholder__rounded' :
    'ImagePlaceholder'},[_c('img',{attrs:{"src":require("@/assets/components/placeholder.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }